// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyDtiU-vJWPQmBwcd_xGmlsMehKnIm4nu7U',
    authDomain: 'yellow-bin.firebaseapp.com',
    projectId: 'yellow-bin',
    storageBucket: 'yellow-bin.appspot.com',
    messagingSenderId: '742165821123',
    appId: '1:742165821123:web:a0c96ac7d82d60d9c0d476',
  },
  mapKey: 'YZDrYaEqqJiH3KwWzaUlSpEnTV3QuLb5sGG7Riqzfq0',
  oneSignalKey: 'de19e064-0ce9-4686-a2d4-3adedd9d12ed',
  yellowbinMail: 'https://mail.yellowbinsa.com/mail.php',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
